angular.module('impactx.requestItem').controller('EditFreeFormCtrl', [
    '$scope',
    'dataGen',
    '$mdDialog',
    'TranslationService',
    'itemId',
    'headerId',
    'entryPointGet',
    'entryPointSave',
    '$controller',
    '$mdToast',
    '$context',
    'lotId',
    'productId',
    'readOnly',
    'materialGroupMappingEntryPoint',
    'changeAATEntryPoint',
    'hideOrderData',
    'headerTable',
    'contractId',
    'themeFactory',
    EditFreeFormCtrl
]);

function EditFreeFormCtrl($scope, dataGen, $mdDialog, TranslationService, itemId, headerId, entryPointGet, entryPointSave,
                          $controller, $mdToast, $context, lotId, productId, readOnly, materialGroupMappingEntryPoint,
                          changeAATEntryPoint, hideOrderData, headerTable, contractId, themeFactory) {

    var init = true;
    $controller('EditRequestItemCtrl', {
        $scope: $scope,
        dataGen: dataGen,
        $mdDialog: $mdDialog,
        TranslationService: TranslationService,
        itemId: itemId,
        headerId: headerId,
        entryPointGet: entryPointGet,
        entryPointSave: entryPointSave,
        $mdToast: $mdToast,
        $context: $context,
        lotId: lotId,
        productId: productId,
        readOnly: readOnly,
        materialGroupMappingEntryPoint: materialGroupMappingEntryPoint,
        changeAATEntryPoint: changeAATEntryPoint,
        hideOrderData: hideOrderData,
        contractId: contractId,
        themeFactory: themeFactory
    });

    var self = this;
    $scope.readOnly = readOnly;
    $scope.invoiceAdr = {};
    $scope.showDeliveryDateGeneral = false;
    $scope.hideExternalComments = false;

    $scope.onContractSelect = function(selected) {
        if(selected && ($scope.oldContractSelected != selected.id)) {
            $scope.contractRequestInProgress = true;
            var tempScope = {};
            dataGen.getData(tempScope, {
                cscId: selected.id,
                headerId: $scope.data.requestItem.headerId,
                itemId: itemId,
                headerTable: headerTable,
                prgId: $scope.data.requestItem.productGroup.selected ? $scope.data.requestItem.productGroup.selected.id : 0
            }, "/basket/contract/updatedata").then(function() {
                $scope.data.requestItem.productGroup.entries = tempScope.data.prg.entries;
                $scope.data.requestItem.productGroup.showMust = tempScope.data.prg.showMust;
                $scope.data.requestItem.purchaserGroups.entries = tempScope.data.pug.entries;
                $scope.data.requestItem.purchaserGroups.showMust = tempScope.data.pug.showMust;
                if (impactX.isDefined($scope, "data.requestItem.purchaserGroups.entries.length") === 1 && $scope.data.requestItem.productGroup.showMust) {
                    $scope.data.requestItem.purchaserGroups.selected = $scope.data.requestItem.purchaserGroups.entries[0];
                }
                if (impactX.isDefined($scope, "data.requestItem.productGroup.entries.length") === 1 && $scope.data.requestItem.purchaserGroups.showMust) {
                    $scope.data.requestItem.productGroup.selected = $scope.data.requestItem.productGroup.entries[0];
                }

                if (tempScope.data.desiredVendors && tempScope.data.desiredVendors.entries) {
                    $scope.data.requestItem.desiredVendors.entries = tempScope.data.desiredVendors.entries;
                }

                $scope.data.requestItem.isBANF = tempScope.data.isBANFContract;
                $scope.data.requestItem.isBANFExported = tempScope.data.isBANFExported;
                $scope.data.requestItem.deliveryDate = tempScope.data.deliveryDate;
                $scope.data.requestItem.firstDeliveryDate = tempScope.data.firstDeliveryDate;
                $scope.data.requestItem.lastDeliveryDate = tempScope.data.lastDeliveryDate;
                $scope.data.requestItem.price.netValue.showMust = !tempScope.data.zeroPrice;
                $scope.data.requestItem.price.netValue.allowNegative = tempScope.data.negativePrice;
                $scope.data.requestItem.amount.noDigits = tempScope.data.noDigits;
                $scope.data.requestItem.outlet = tempScope.data.outlet;
                if ($scope.data.requestItem.eClassSelection) {
                    $scope.data.requestItem.eClassSelection.showMust = tempScope.data.eClassMandatory;
                }
                if (!$scope.data.requestItem.naBeSelection) {
                    $scope.data.requestItem.naBeSelection = tempScope.data.naBeSelection;
                }
                else if (!tempScope.data.naBeSelection) {
                    $scope.data.requestItem.naBeSelection = null;
                }
                else {
                    if ($scope.data.requestItem.naBeSelection.selected && $scope.data.requestItem.naBeSelection.selected.id === 0
                        && tempScope.data.naBeSelection.entries.length === 2) {
                        $scope.data.requestItem.naBeSelection.selected = null;
                    }
                    $scope.data.requestItem.naBeSelection.showMust = tempScope.data.naBeSelection.showMust;
                    $scope.data.requestItem.naBeSelection.entries = tempScope.data.naBeSelection.entries;
                }

                if (tempScope.data.foreignOrderData) {
                    $scope.data.requestItem.foreignOrderData = tempScope.data.foreignOrderData;
                }
                
                if (tempScope.data.preSetEClass) {
                    if (!$scope.data.requestItem.eClassSelection.selected) {
                        $scope.data.requestItem.eClassSelection.selected = tempScope.data.preSetEClass
                    }
                }

                $scope.data.requestItem.isCPDContract = tempScope.data.isCPDContract;
                if ($scope.data.requestItem.isCPDContract && !$scope.data.requestItem.cpdAddress) {
                    $scope.data.requestItem.cpdAddress = tempScope.data.cpdAddress;
                    $scope.trns.requiredError = TranslationService.get("required");
                    $scope.trns.requiredError = TranslationService.get("required");
                }
                // remove inv addresses if fixed but keep it in background, since user can change the contract
                if(tempScope.data.invoiceAdrFixed) {
                    $scope.invoiceAdr = $scope.data.requestItem.invoiceAddresses;
                    $scope.data.requestItem.invoiceAddresses = null;
                } else if($scope.invoiceAdr && !$scope.data.requestItem.invoiceAddresses) {
                    $scope.data.requestItem.invoiceAddresses = $scope.invoiceAdr;
                    $scope.invoiceAdr = null;
                }

                if (tempScope.data.isBANFContract) {

                    $scope.showDeliveryDateGeneral = true;

                    $scope.data.requestItem.price.currency.entries = tempScope.data.availableCurrencies;

                    if ($scope.data.requestItem.price.currency.selected) {
                        
                        var entries = $.grep($scope.data.requestItem.price.currency.entries, function (entry) {
                            return entry.id == $scope.data.requestItem.price.currency.selected.id;
                        });

                        //remove the selected currency if no longer allowed after contract change
                        if (entries.length === 0) {
                            $scope.data.requestItem.price.currency.selected = undefined;
                        }
                    }
                    
                    if(!tempScope.data.comments) {
                        $scope.hideExternalComments = true;
                    }
                }
                else {
                    $scope.showDeliveryDateGeneral = false;
                    $scope.hideExternalComments = false;
                }

                if ($scope.data.requestItem.comments && tempScope.data.comments) {
                    if($scope.data.requestItem.comments.externalComments && tempScope.data.comments.externalComments)
                    {
                        $scope.data.requestItem.comments.externalComments.attachmentRequired = tempScope.data.comments.externalComments.attachmentRequired;
                        $scope.data.requestItem.comments.externalComments.attachmentRequiredNoValidation = tempScope.data.comments.externalComments.attachmentRequiredNoValidation;
                        $scope.data.requestItem.comments.externalComments.inputTranslation = tempScope.data.comments.externalComments.inputTranslation;
                        $scope.data.requestItem.comments.externalComments.attachmentsAllowed = tempScope.data.comments.externalComments.attachmentsAllowed;
                        $scope.data.requestItem.comments.externalComments.readOnly = tempScope.data.comments.externalComments.readOnly;
                    }
                    if($scope.data.requestItem.comments.internalComments && tempScope.data.comments.internalComments)
                    {
                        $scope.data.requestItem.comments.internalComments.attachmentRequired = tempScope.data.comments.internalComments.attachmentRequired;
                        $scope.data.requestItem.comments.internalComments.attachmentRequiredNoValidation = tempScope.data.comments.internalComments.attachmentRequiredNoValidation;
                    }
                }

                init = false;
            }).finally(function () {
                $scope.contractRequestInProgress = false;
            });
            $scope.oldContractSelected = selected.id;
        }
        else {
            if(!selected) {
                if($scope.data.requestItem.productGroup.entries) {
                    $scope.data.requestItem.productGroup.entries.length = 0;
                    $scope.data.requestItem.productGroup.selected = {};
                }
                $scope.oldContractSelected = 0;
                $scope.data.requestItem.price.netValue.showMust = true;
            }
        }
    };

    $scope.onProductGroupSelect = function (selected) {
        var prgId = 0;
        var cscId = $scope.data.requestItem.contract.selected.id;
        if(selected) {
            prgId = selected.id;
        }
        if (impactX.isDefined($scope, 'data.requestItem.contract.selected.id')) {
            $scope.contractRequestInProgress = true;
            dataGen.postAsForm({}, {
                aatId: impactX.isDefined($scope, 'data.requestItem.aat.selected.id'),
                itemId: $scope.data.requestItem.id,
                headerId: $scope.data.requestItem.headerId,
                cscId: cscId,
                prgId: prgId
            }, changeAATEntryPoint).then(function (result) {
                if (result && result.data) {
                    $scope.data.requestItem.control = result.data;
                }
                $scope.contractRequestInProgress = false;
            });
        }

        dataGen.getData({}, {prgId: prgId, cscId: cscId}, "/basket/prg/changed").then(function(result) {
            if (result && result.data) {
                $scope.data.requestItem.purchaserGroups = result.data;
                if (impactX.isDefined($scope, "data.requestItem.purchaserGroups.entries.length") === 1 && $scope.data.requestItem.productGroup.showMust) {
                    $scope.data.requestItem.purchaserGroups.selected = $scope.data.requestItem.purchaserGroups.entries[0];
                }
            }
        });
    };

    $scope.updateMaterialGroupMapping = function(selected) {
        $scope.eClassDataArray = [{field: "eClass", value: selected ? selected.value : null},
            {field: "sapConfigId", value: $scope.data.requestItem.sapConfigId}];

        if ($scope.data.requestItem.eClassMaterialGroupMapping) {
            if (!selected) {
                $scope.data.requestItem.eClassMaterialGroupMapping.selected = null;
            }
            else {
                var tempScope = {};
                dataGen.getData(tempScope, {
                    eClass: selected.secondValue,
                    sapConfigId: $scope.data.requestItem.sapConfigId
                }, "/basket/freeform/materialgroupmappingforeclass").then(function() {
                    $scope.data.requestItem.eClassMaterialGroupMapping.selected = tempScope.data.newMapping;
                });
            }
        }
    };

    $scope.changeAat = function (aatId, itemId) {
        if (impactX.isDefined($scope, 'data.requestItem.contract.selected.id')) {
            dataGen.postAsForm({}, {
                aatId: aatId,
                itemId: itemId,
                headerId: $scope.data.requestItem.headerId,
                cscId: $scope.data.requestItem.contract.selected.id,
                prgId: impactX.isDefined($scope, 'data.requestItem.productGroup.selected.id')
            }, changeAATEntryPoint).then(function (result) {
                if (result && result.data) {
                    $scope.data.requestItem.control = result.data;
                }
            });
        }
    };
}
